import React, { Component } from "react";
import _ from "lodash";
import { Image, Popup } from "semantic-ui-react";
import HomeValue from "../../assets/images/homeval.jpg.png";
import Income from "../../assets/images/incomeNew.png";
import Pin from "../../assets/images/pin.png";
import { getNodeValue } from "../common/Utils";

class Address extends Component {
  componentDidMount() {}

  render() {
    const addressNode = this.props.addressNode;
    let addLine1 = getNodeValue(addressNode, "line1") || "";
    if (addLine1 === "") {
      addLine1 = _.get(addressNode, "streetAddress1[0]._", "");
    }
    if (addLine1 === "") {
      addLine1 = _.get(addressNode, "address[0]._", "");
    }
    if (addLine1 === "") {
      const houseNumber = _.get(addressNode, "houseNumber[0]._", "");
      const preDirection = _.get(addressNode, "preDirection[0]._", "");
      const streetName = _.get(addressNode, "streetName[0]._", "");
      const streetNumber = _.get(addressNode, "streetNumber[0]._", "");
      let unitNumber = _.get(addressNode, "unitNumber[0]._", "");
      if (unitNumber === "")
        unitNumber = _.get(addressNode, "unitDesignatorNumber[0]._", "");
      const streetSuffix = _.get(addressNode, "streetSuffix[0]._", "");
      addLine1 = `${houseNumber !== "" ? `${houseNumber} ` : ""}${
        preDirection !== "" ? `${preDirection} ` : ""
      }${streetNumber}${streetName === "" ? "" : ` ${streetName}`}${
        streetSuffix === "" ? "" : ` ${streetSuffix}`
      }${unitNumber === "" ? "" : ` ${unitNumber}`}`;
    }
    let addressText = _.get(addressNode, "address1[0]._", "");
    if (this.props.fullAddress !== undefined) {
      addressText = this.props.fullAddress;
    }
    if (addressText === "") {
      addressText = _.get(addressNode, "address[0]._", "");
    }
    if (addressText === "") {
      addressText = addLine1;
    }
    const city = getNodeValue(addressNode, "city");
    if ((!city || city === "") && addressText === "") {
      const streetNumber = _.get(addressNode, "streetNumber._", "");
      const streetName = _.get(addressNode, "streetName._", "");
      if (streetNumber !== "" || streetName !== "") {
        return (
          <Popup
            trigger={
              <Image
                src={Pin}
                className={"icon-display-link"}
                onClick={this.props.handleMapClick(
                  this,
                  `${streetNumber} ${streetName}`
                )}
                spaced
              />
            }
            position="top center"
          >
            Click to view map
          </Popup>
        );
      }
      return <span />;
    }
    const state = getNodeValue(addressNode, "state");
    let zipcode = getNodeValue(addressNode, "zip") || "";
    if (!zipcode || zipcode === "") {
      const zip5 = _.get(addressNode, "zip5[0]._", "");
      if (zip5 !== "") {
        zipcode = zip5;
      } else {
        const zip4 = _.get(addressNode, "zip4[0]._", "");
        if (zip4 !== "") {
          zipcode = zip4;
        }
      }
    }
    if (zipcode === "") {
      zipcode = _.get(addressNode, "postalCode[0]._", "");
    }
    const address = {
      address: addLine1 !== "" ? addLine1 : addressText,
      city,
      state,
      zipcode,
    };
    const mapAddress = `${addLine1.replace(" ", "+")}+${zipcode}`;
    return (
      <span>
        {this.props.showIcons !== "false" && (
          <span className={`no-print`}>
            {!this.props.hideHomeValue && (
              <Popup
                trigger={
                  <Image
                    className={"icon-display-link"}
                    src={HomeValue}
                    onClick={
                      state !== ""
                        ? () =>
                            this.props.handleHomeValueClick(
                              this,
                              zipcode,
                              address.address
                            )
                        : null
                    }
                    spaced
                  />
                }
                position="top center"
              >
                <span className="address-icons-tooltip">
                  Click to see home value demographics
                </span>
              </Popup>
            )}
            {!this.props.hideHomeIncome && (
              <Popup
                trigger={
                  <Image
                    className={"icon-display-link"}
                    src={Income}
                    onClick={
                      state !== ""
                        ? () =>
                            this.props.handleHomeIncomeClick(
                              this,
                              zipcode,
                              address.address
                            )
                        : null
                    }
                    spaced
                  />
                }
                position="top center"
              >
                <span className="address-icons-tooltip">
                  Click to see income demographics
                </span>
              </Popup>
            )}
            <Popup
              trigger={
                <Image
                  src={Pin}
                  className={"icon-display-link"}
                  onClick={
                    state !== ""
                      ? () => this.props.handleMapClick(this, mapAddress)
                      : null
                  }
                  spaced
                />
              }
              position="top center"
            >
              <span className="address-icons-tooltip">Click to view map</span>
            </Popup>

            {(this.props.noBreakIconsAndText === undefined ||
              this.props.noBreakIconsAndText !== true) && <br />}
          </span>
        )}{" "}
        <span
          role="button"
          tabIndex={0}
          className={"background-color-transparent url-link"}
          onClick={() =>
            this.props.handleNewSearchClick(
              this,
              "Address",
              addressText,
              address
            )
          }
        >
          {addressText}
          {this.props.ignoreLine1 !== "true"
            ? `${addressText !== addLine1 ? addLine1 : ""}, `
            : ""}
          <br />
          {`${city}, ${state}  ${zipcode}`}
        </span>
      </span>
    );
  }
}

export default Address;



// WEBPACK FOOTER //
// ./src/components/searchresults/Address.js